import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { Checkbox, FormControl, ListItemText, MenuItem, InputLabel, Select } from '@material-ui/core';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as classes from './SelectEquipmentTypeModal.module.css';

const SelectEquipmentTypeModal = ({
    equipmentTypes,
    equipmentTypesLoading,
    setSelectedEquipmentTypes,
    setSelectedSystems,
    toggleSelectEquipmentTypeModalOpen,
    systems,
    systemsLoading,
    ...props
}) => {
    const [targetEquipmentTypes, setTargetEquipmentTypes] = useState([]);
    const [types, setTypes] = useState([]);
    const [targetSystems, setTargetSystems] = useState([]);
    const [siteSystems, setSiteSystems] = useState([]);
    const [selectAllSystems, setSelectAllSystems] = useState(false);
    const [selectAllEquipmentTypes, setSelectAllEquipmentTypes] = useState(false);

    useEffect(() => {
        setSiteSystems(systems);
    }, [systems]);

    useEffect(() => {
        if (equipmentTypes.data) setTypes(equipmentTypes.data);
    }, [equipmentTypes]);

    const handleChange = (event, value) => {
        if (value.props.value === 'all') {
            if (!selectAllEquipmentTypes) {
                setTargetEquipmentTypes(types);
            } else {
                setTargetEquipmentTypes([]);
            }

            setSelectAllEquipmentTypes(!selectAllEquipmentTypes);
            return;
        }

        if (event.target.value.length === types.length) {
            setSelectAllEquipmentTypes(true);
        } else {
            setSelectAllEquipmentTypes(false);
        }

        setTargetEquipmentTypes(event.target.value);
    };

    const handleChangeSystem = (event, value) => {
        if (value.props.value === 'all') {
            if (!selectAllSystems) {
                setTargetSystems(siteSystems);
            } else {
                setTargetSystems([]);
            }

            setSelectAllSystems(!selectAllSystems);
            return;
        }

        if (event.target.value.length === siteSystems.length) {
            setSelectAllSystems(true);
        } else {
            setSelectAllSystems(false);
        }

        setTargetSystems(event.target.value);
    };

    const handleSetEquipmentType = () => {
        setSelectedEquipmentTypes(targetEquipmentTypes);
        setSelectedSystems(targetSystems);
        toggleSelectEquipmentTypeModalOpen(false);
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 400
            },
        },
    };

    return (
        <BobModal
            title={'Select an Equipment Type or System'}
            confirmText="Ok"
            isRemoveFooter={true}
            hidebuttons={true}
            onConfirm={handleSetEquipmentType}
            onClose={() => toggleSelectEquipmentTypeModalOpen(false)}
        >
            <div className={classes.Body}>
                <div className={classes.SubHeader}>
                    <div className={classes.Icon}><i className="fas fa-info-circle" /></div>
                    <div>Please select an Equipment Type or System to load the equipment</div>
                </div>
                <div>
                    <FormControl variant="outlined" size="small" className={classes.SelectContainer}>
                        <InputLabel
                            style={{
                                backgroundColor: 'white',
                                paddingRight:    '5px'
                            }}
                            htmlFor="outlined-contact-native-simple"
                        >
                            {systemsLoading ? 'Loading systems' : isEmpty(siteSystems) ? 'No systems exist' : 'Systems' }
                        </InputLabel>
                        <Select
                            MenuProps={MenuProps}
                            multiple
                            value={targetSystems}
                            disabled={isEmpty(siteSystems) || systemsLoading}
                            onChange={handleChangeSystem}
                            label="system"
                            renderValue={(selected) => selected.length === 1 ? `${selected.length} System Selected` : `${selected.length} Systems Selected`}
                            inputProps={{
                                name: 'system',
                                id:   'outlined-contact-native-simple',
                            }}
                        >
                            <MenuItem value="none" disabled>
                                Select System
                            </MenuItem>
                            <MenuItem value="all">
                                <Checkbox style={{ color: 'black' }} checked={selectAllSystems} />
                                <ListItemText primary="Select all" />
                            </MenuItem>
                            {siteSystems.map((system, index) => (
                                <MenuItem key={index} value={system}>
                                    <Checkbox style={{ color: 'black' }} checked={targetSystems.indexOf(system) > -1} />
                                    <ListItemText primary={system.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" size="small" className={classes.TypeSelectContainer}>
                        <InputLabel
                            style={{
                                backgroundColor: 'white',
                                paddingRight:    '5px'
                            }}
                            htmlFor="outlined-contact-native-simple"
                        >
                            {equipmentTypesLoading || isEmpty(equipmentTypes.data) ? 'Loading equipment types' : isEmpty(types) ? 'No equipment types exist' : 'Equipment Types' }
                        </InputLabel>
                        <Select
                            MenuProps={MenuProps}
                            multiple
                            value={targetEquipmentTypes}
                            disabled={isEmpty(types) || equipmentTypesLoading}
                            onChange={handleChange}
                            label="EquipmentType"
                            renderValue={(selected) => selected.length === 1 ? `${selected.length} Type Selected` : `${selected.length} Types Selected`}
                            inputProps={{
                                name: 'equipmentType',
                                id:   'outlined-contact-native-simple',
                            }}
                        >
                            <MenuItem value="none" disabled>
                                Select Equipment Type
                            </MenuItem>
                            <MenuItem value="all">
                                <Checkbox style={{ color: 'black' }} checked={selectAllEquipmentTypes} />
                                <ListItemText primary="Select all" />
                            </MenuItem>
                            {types.map((type, index) => (
                                <MenuItem key={index} value={type}>
                                    <Checkbox style={{ color: 'black' }} checked={targetEquipmentTypes.indexOf(type) > -1} />
                                    <ListItemText primary={type.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        onClick={() => toggleSelectEquipmentTypeModalOpen(false)}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        disabled={isEmpty(targetEquipmentTypes) && isEmpty(targetSystems)}
                        onClick={() => handleSetEquipmentType()}
                        className={isEmpty(targetEquipmentTypes) && isEmpty(targetSystems) ? classes.DisabledButtons : classes.Buttons}
                        label={'Ok'}
                    />
                </div>
            </div>
        </BobModal>
    );
};

export default SelectEquipmentTypeModal;
